import React from 'react';

import { EmptyPageState, MainPage } from '../../components';
import { RightStudioDrawer } from '../../components/RightDrawer/RightStudioDrawer';

export const AnalyticsScreen = () => {
  const isDialogOpen = false;

  const handleOpenDialog = () => {}

  const isShouldShowEmptyState = true;

  return (
    <MainPage
      title="Analytics"
      isDialogOpen={isDialogOpen}
      isShouldShowEmptyState={isShouldShowEmptyState}
      onAddButtonClick={handleOpenDialog}
      DialogComp={<></>}
      DrawerComp={<></>}
      EmptyStateComp={<EmptyPageState
        image="/images/empty-page-states/analytics.png"
        title="Currently, there is no analytics data available for display"
        subTitle="Access to the Analytics Dashboard requires relevant data inputs. To unlock the power of analytics, start by managing your staff members, services, scheduling appointments. Once data is available, the Analytics Dashboard will provide valuable insights."
      />}
    >
      <main className="main-page">
        here should be analytics screen
      </main>
    </MainPage>
  );
}
